import { COMMUNITY_ROLES } from '@/constants/community-roles';
import { ACCOUNT_ROLES } from '@/constants/account-roles';
import { useUser } from './use-user';

/**
 * Provides role-level helpers for the current user in the selected community.
 */
export function useCommunityRole() {
  const { community, account } = useUser();

  const communityRoles: string[] = community?.roles ?? [];
  const accountRoles: string[] = account?.roles ?? [];

  const isCommunityManager = communityRoles.includes(COMMUNITY_ROLES.COMMUNITY_MANAGER);
  const isBoardMember = communityRoles.includes(COMMUNITY_ROLES.BOARD_MEMBER);
  const isAccountAdmin = accountRoles.some((r) =>
    [ACCOUNT_ROLES.ACCOUNT_OWNER, ACCOUNT_ROLES.ACCOUNT_ADMIN, ACCOUNT_ROLES.ACCOUNT_MANAGER].includes(r)
  );

  /** True for community managers and board members — can see all requests and internal messages */
  const hasBoardLevelAccess = isCommunityManager || isBoardMember || isAccountAdmin;

  /** True for community managers and account admins — can manage the full request lifecycle */
  const hasManagerAccess = isCommunityManager || isAccountAdmin;

  return {
    isCommunityManager,
    isBoardMember,
    isAccountAdmin,
    hasBoardLevelAccess,
    hasManagerAccess,
  };
}
